import React from 'react';
import { Link } from 'react-router-dom';
import { Seo } from '@/components/Seo';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import { SITE } from '@/data/site-config';

export default function ThankYouPage() {
  return (
    <>
      <Seo title="Thank you" description="Your message was received." canonical="/thank-you" noindex />
      <section className="container-x py-20 text-center max-w-2xl mx-auto">
        <CheckCircle2 size={48} className="text-accent mx-auto" />
        <h1 className="font-display text-4xl md:text-5xl font-bold mt-5">Got it — we’ll be in touch.</h1>
        <p className="text-[color:var(--ft-muted)] text-lg mt-4">Thanks for reaching out. We’ll follow up within a business day. If you’d rather talk now, call us directly.</p>
        <div className="mt-7 flex flex-wrap justify-center gap-3">
          <a href={`tel:${SITE.phoneE164}`} className="btn btn-primary btn-lg">Call {SITE.phone}</a>
          <Link to="/" className="btn btn-secondary btn-lg">Back to home <ArrowRight size={16} /></Link>
        </div>
      </section>
    </>
  );
}
